import { Button, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Context } from "../../../context/context";
import {
  editFreightCostByCompany,
  getFreightCostById,
} from "../../../services/freight-cost-service";
import EditIcon from "@mui/icons-material/Edit";

import "./CitiesById.scss";

export default function CitiesById() {
  const accessToken = localStorage.getItem("token");
  const { sidebar } = useContext(Context);
  const [data, setData] = useState({});
  const [isEditable, setIsEditable] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  function getStateName(uf_id) {
    if (uf_id === 26) return "SP";
    if (uf_id === 11) return "MG";
    if (uf_id === 9) return "GO";
  }

  function handleChange(e) {
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  function handleChangeNumbers(e) {
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: +e.target.value,
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      const dataWithoutCity = { ...data };
      delete dataWithoutCity["city"];

      const result = await editFreightCostByCompany(
        accessToken,
        dataWithoutCity
      );

      alert("Cidade atualizada com sucesso.");
      navigate("/cidades");
      console.log(result);
    } catch (error) {
      alert("Algo deu errado. Tente novamente mais tarde.");
    }
  }

  useEffect(() => {
    async function getCityData() {
      const [result] = await getFreightCostById(accessToken, id);
      setData(result);
    }
    getCityData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className={sidebar ? "container" : "container-full"}>
      <div className="title-edit-btn">
        <h1>Dados da Cidade</h1>
        <button onClick={() => setIsEditable(!isEditable)}>
          <EditIcon />
        </button>
      </div>
      <div className="inputs-container">
        {data.city && (
          <>
            <div className="inputs-container__name-cnpj">
              <TextField
                fullWidth
                label="UF"
                name="uf"
                value={getStateName(data.uf_id)}
                disabled
              />
              <TextField
                fullWidth
                label="Cidade"
                name="city"
                value={data.city}
                onChange={handleChange}
                disabled
              />
              <TextField
                fullWidth
                label="Custo Entrega"
                name="custo_entrega"
                value={data.custo_entrega}
                type="number"
                onChange={handleChangeNumbers}
                disabled={isEditable}
              />
              <TextField
                fullWidth
                label="Km Idv"
                name="km_idv"
                type="number"
                value={data.km_idv}
                onChange={handleChangeNumbers}
                disabled={isEditable}
              />
            </div>
            <div className="save-btn-container">
              <Button
                className="save-btn-container__save-btn"
                variant="contained"
                onClick={handleSubmit}
              >
                Salvar
              </Button>
              <Button onClick={() => navigate("/cidades")} variant="outlined">
                Voltar
              </Button>
            </div>
          </>
        )}
      </div>
    </main>
  );
}
